import { z } from 'zod';
import { BED_OPTIONS } from '../catalog/bedOptions.js';
import { BED_TYPES, MAX_BED_SIZE_CM, MIN_BED_SIZE_CM } from '../catalog/bedTypes.js';
import { idSchema } from './common.js';
export const bedTypeSchema = z.enum(BED_TYPES);
export const bedOptionSchema = z.enum(BED_OPTIONS);
export const bedSizeSchema = z
    .number()
    .int('Size must be a whole number of centimetres')
    .min(MIN_BED_SIZE_CM)
    .max(MAX_BED_SIZE_CM);
/** Favourite guests are an ordered preference list, best first, no duplicates. */
export const favoriteGuestIdsSchema = z
    .array(idSchema)
    .max(20)
    .refine((ids) => new Set(ids).size === ids.length, {
    error: 'A guest can only appear once in the favourites list',
});
export const createBedInputSchema = z.strictObject({
    type: bedTypeSchema,
    /** Omitted means "use the default width for this bed type". */
    sizeCm: bedSizeSchema.nullish(),
    option: bedOptionSchema.default('standard'),
    favoriteGuestIds: favoriteGuestIdsSchema.default([]),
});
export const updateBedInputSchema = z
    .strictObject({
    type: bedTypeSchema,
    sizeCm: bedSizeSchema.nullish(),
    option: bedOptionSchema,
    favoriteGuestIds: favoriteGuestIdsSchema,
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    error: 'Provide at least one field to update',
});
//# sourceMappingURL=beds.js.map